// Tastenkappen (Entwurf v4 `kbd`): je Taste eine eigene Kappe in der
// Markenschrift statt Festbreite -- das Zeichen ist ein Hinweis, kein Code.

import type { ReactNode } from 'react';
import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';

import { SCHMUCK_ATTRIBUT, useSchmuckStyles } from './schmucktext.ts';

const useStyles = makeStyles({
  folge: { display: 'inline-flex', alignItems: 'center', gap: '0.1875rem', flexShrink: 0, whiteSpace: 'nowrap' },
  kappe: {
    fontFamily: 'inherit',
    fontSize: '0.71875rem', // v4 11,5 px
    lineHeight: '1.125rem',
    padding: '0 0.3125rem',
    border: `1px solid ${tokens.colorNeutralStroke1}`,
    borderBottomWidth: '2px',
    borderRadius: tokens.borderRadiusSmall,
    backgroundColor: tokens.colorNeutralBackground2,
    color: tokens.colorNeutralForeground2,
  },
});

/**
 * Eine Tastenfolge wie "G K" oder "Strg K": je durch Leerzeichen getrennte Taste eine Kappe.
 * `stumm` neben einer Beschriftung: die Zeichen sind dann Schmucktext (schmucktext.ts), sonst
 * gehoerten sie zur sichtbaren Beschriftung des Eintrags und fehlten in seinem Namen (WCAG 2.5.3).
 */
export function Tasten({ folge, stumm = false }: { readonly folge: string; readonly stumm?: boolean }): ReactNode {
  const styles = useStyles();
  const schmuck = useSchmuckStyles();
  const tasten = folge.split(' ').filter((taste) => taste.length > 0);
  return (
    <span className={styles.folge} {...(stumm ? { 'aria-hidden': true } : {})}>
      {tasten.map((taste, index) =>
        stumm ? (
          <kbd key={`${index}-${taste}`} className={mergeClasses(styles.kappe, schmuck.schmuck)} {...{ [SCHMUCK_ATTRIBUT]: taste }} />
        ) : (
          <kbd key={`${index}-${taste}`} className={styles.kappe}>
            {taste}
          </kbd>
        ),
      )}
    </span>
  );
}
